import { createSlice } from '@reduxjs/toolkit';
import { format, subDays } from 'date-fns';

export const DEFAULT_EVENTS_LOOKBACK_DAYS = 90;

export const getDefaultEventsDateRange = () => [
  format(subDays(new Date(), DEFAULT_EVENTS_LOOKBACK_DAYS), 'yyyy-MM-dd'),
  format(new Date(), 'yyyy-MM-dd'),
];

const initialState = {
  eventTypes: [],
  events: {
    currentPage: 1,
    pages: {},
    count: 0,
    filter: {
      createdAt: getDefaultEventsDateRange(),
      eventType: undefined,
      pomUserName: undefined,
    },
    sortBy: {
      sortKey: 'createdTimestamp',
      sortOrder: 'ASC',
    },
    eventLoading: false,
  },
};

/* eslint no-param-reassign: ["error", { "ignorePropertyModificationsFor": ["state"] }] */
const eventSlice = createSlice({
  name: 'criticalEvents',
  initialState,
  reducers: {
    loadEventTypes(state, action) {
      state.eventTypes = action.payload;
    },
    loadEvents(state, action) {
      const { page, events, count } = action.payload;

      state.events.pages[page] = events;
      state.events.count = count;
    },
    updateEventsCurrentPage(state, action) {
      const { page } = action.payload;
      state.events.currentPage = page;
    },
    updateSortBy(state, action) {
      const { sortBy } = action.payload;

      state.events.pages = {}; // Cached data no longer valid, this is to reset it.
      state.events.count = 0;
      state.events.sortBy = sortBy;
    },
    updateFilter(state, action) {
      const { filter } = action.payload;

      state.events.pages = {}; // Cached data no longer valid, this is to reset it.
      state.events.count = 0;
      state.events.filter = filter;
    },
    setEventLoading(state, action) {
      state.events.eventLoading = action.payload;
    },
  },
});

export const eventActions = eventSlice.actions;
export default eventSlice.reducer;
